import type { Snippet } from "svelte";
import type Bubble from "./Bubble.svelte";

export enum PopoverPosition {
  TOP = "top",
  BOTTOM = "bottom",
}

export type PopoverPositioningResult = {
  anchorLeftPosition: number | false;
  position: `${PopoverPosition}`;
  popoverStyles: Record<string, string>;
};

export type PopoverProps = {
  contextElement?: HTMLElement | null;
  bubble: typeof Bubble;
  show?: boolean;
  sticky?: boolean;
  preferredPosition?: `${PopoverPosition}`;
  onFullyShown?: () => void;
  children: Snippet;
};
